import React from "react";
import './SortandFilter.css';
import DropDown from "../Dropdown/DropDown";
const SortandFilter = () => {
    return (
            <div className="filterside">
                <div className="left-side">
                <DropDown name="category" />
                {/* <DropDown name="size" /> */}
                <DropDown name="price" />
                <DropDown name="color" />
                </div>
                <div className="right-side">
                <DropDown name="sort by" />
                </div>
            </div>

    )
};

export default SortandFilter;